import React from 'react';

const WhatsappBtn = () => {
  const link = `https://wa.me/201050549994`;


  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="floating-wa"
    >
      <img
        src="/images/whatsapp.svg"
        alt="WhatsApp"
      />
    </a>
  );
}

export default WhatsappBtn;